import React from 'react'
import { INavAdvertisement } from '../../interfaces/Navigation.Interface.Header'
import Icon from '../../../svg/Icon'
const Advertisement = (item: INavAdvertisement) => {
  return (
    <>
      <div className="advertisement">
        <a href={item.absolute}>
          <Icon name={item.icon} />
        </a>
        <h4>
          <a href={item.secondary.absolute}>{item.secondary.title}</a>
        </h4>
        <p>
          <a href={item.tertiary.absolute}>{item.tertiary.title}</a>
        </p>
      </div>
    </>
  )
}

export default Advertisement
